import React from 'react';
import '../assets/headerCat.css'

function HeaderCat(props) {
  return (
    <div>
    <div className="container-fluid header-cat" id='header'>
        <img  src={window.location.origin +props.image} alt='' />
        <div className="header cat-props-tile pe-2">
            <h6 className="ml-5 ">{props.title}</h6>
            <p className="ml-5">{props.subtitle} </p>
        </div>
    </div>
    </div>
  )
}

export default HeaderCat
